<div
  *ngIf="!loading"
  class="px-3 pt-3 pb-4">
  <p class="font-medium text-2xl">Выберите или вставьте свой вариант письма</p>

  <div class="p-fluid text-left mt-4">
    <div class="field">
      <label class="font-medium required-field">Название</label>
      <crm-auto-complete
        [suggestions]="filterTemplates"
        [value]="newsletter.name"
        [dropdown]="true"
        field="name"
        [isWithStringValue]="true"
        (valueChange)="changeTemplate($event)"
        (completeMethod)="searchTemplates($event)"
        appendTo="body"
        [isError]="$any(errors?.name)"
        [autofocus]="true"></crm-auto-complete>
      <small
        *ngIf="errors?.name"
        class="p-error">
        {{ errors.name | join }}
      </small>
    </div>

    <div class="field">
      <label class="font-medium required-field">Тема письма</label>
      <crm-template-subject-input
        [(subject)]="newsletter.title"
        [isError]="$any(errors?.title)"
        class="w-full"></crm-template-subject-input>
      <small
        *ngIf="errors?.title"
        class="p-error">
        {{ errors.title | join }}
      </small>
    </div>

    <div class="field">
      <label class="font-medium required-field">Текст сообщения</label>
      <crm-template-subject-editor
        [(value)]="newsletter.text"
        height="250px"></crm-template-subject-editor>
      <small
        *ngIf="errors?.text"
        class="p-error">
        {{ errors.text | join }}
      </small>
    </div>
  </div>

  <div class="flex justify-content-center mt-6">
    <button
      pButton
      type="button"
      label="Далее"
      icon="pi pi-arrow-right"
      iconPos="right"
      class="p-button-success p-button-lg"
      (click)="nextClick()"></button>
  </div>
</div>

<crm-spinner *ngIf="loading"></crm-spinner>
